import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { VimeoPlayerComponent } from '@df/ui/display/media/vimeo-player.component';
import { injectTimeoutService } from '@df/ng/timeout.service';
@Component({
    selector: 'local-vimeo-player',
    template: `
        <div #container></div>
        @if ((!background && ((!autoplay && !autoplayInViewport) || isPlaying || showControl)) || controls) {
            <div class="video-player-control" [class.is-playing]="isPlaying">
                @if (playButton && !isPlaying) {
                    <div class="icon-control icon-video-play" (click)="play()">
                        <ng-container *ngTemplateOutlet="playButton; context: { $implicit: this }" />
                    </div>
                }
                @if (pauseButton && isPlaying) {
                    <div class="icon-control icon-video-pause" (click)="pause()">
                        <ng-container *ngTemplateOutlet="pauseButton; context: { $implicit: this }" />
                    </div>
                }
            </div>
        }
        <ng-container *ngTemplateOutlet="customTpl; context: { $implicit: this }" />
        @if (progressBar) {
            <div class="video-player-progress" [class.is-playing]="isPlaying" [class.show-control]="showControl">
                <div #videoProgressBar class="video-player-progress-percent"></div>
            </div>
        }
    `,
    styleUrl: './vimeo-player.component.scss',
    standalone: true,
    imports: [CommonModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[class.video-player-container]': '!!componentId'
    }
})
export class LocalVimeoPlayerComponent extends VimeoPlayerComponent implements OnInit {
    protected readonly disposableTimeoutService = injectTimeoutService();

    override ngOnInit(): void {
        this.elementRef.nativeElement.style.setProperty('visibility', 'hidden');
        super.ngOnInit();

        this.subscriptions.add(this.playerInit.subscribe(player => this.handlePlayerInit(player)));
    }

    handlePlayerInit(player: VimeoPlayerComponent) {
        const { width, height } = this.elementRef.nativeElement.getBoundingClientRect();

        Promise.all([player.playerInstance.getVideoWidth(), player.playerInstance.getVideoHeight()]).then(dimensions => {
            const [videoWidth, videoHeight] = dimensions;

            let _width = 100;
            let _height = 100;
            let _top = 0;
            let _left = 0;

            if (videoWidth > videoHeight) {
                const proportion = videoWidth / width;
                const newHeight = videoHeight / proportion;

                if (newHeight > height) {
                    const newProportion = newHeight / height;
                    _height = 100 * newProportion;
                } else {
                    const newProportion = height / newHeight;
                    _width = 100 * newProportion;
                }
            } else {
                const proportion = videoHeight / height;
                const newWidth = videoWidth / proportion;

                if (newWidth > width) {
                    const newProportion = newWidth / width;
                    _width = 100 * newProportion;
                } else {
                    const newProportion = width / newWidth;
                    _height = 100 * newProportion;
                }
            }

            if (_width > 100) {
                _left = (100 - _width) / 2;
            }

            if (_height > 100) {
                _top = (100 - _height) / 2;
            }

            this.elementRef.nativeElement.style.setProperty('--video-layout-width', `${_width}%`);
            this.elementRef.nativeElement.style.setProperty('--video-layout-height', `${_height}%`);
            this.elementRef.nativeElement.style.setProperty('--video-layout-top', `${_top}%`);
            this.elementRef.nativeElement.style.setProperty('--video-layout-left', `${_left}%`);
            this.elementRef.nativeElement.style.setProperty('--video-layout-opacity', '1');
            this.disposableTimeoutService.setTimeout(() => this.elementRef.nativeElement.style.setProperty('visibility', 'visible'), 100);
        });
    }
}
